<template>
  <div class="row">
    <div class="col-md-12 mb-3">
      <router-link to="/principal/modules/add" class="btn btn-secondary" v-if="$can('create', 'Permisos')">
        Agregar Modulo
      </router-link>
    </div>
    <div class="col-md-12">
      <vue-good-table
        mode="remote"
        :columns="columns"
        :rows="rows"
        :totalRows="totalRecords"
        :sort-options="{
          enabled: true,
        }"
        :isLoading.sync="isLoading"
        styleClass="vgt-table bordered"
        :pagination-options="{
          enabled: true,
          mode: 'registros',
          position: 'top',
          perPage: 10,
          nextLabel: 'siguiente',
          prevLabel: 'anterior',
          rowsPerPageLabel: 'Filas por página',
          ofLabel: 'de',
          pageLabel: 'páginas', // for 'pages' mode
          allLabel: 'Todos',
        }"
        @on-page-change="onPageChange"
        @on-sort-change="onSortChange"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'actions'">
            <button v-if="$can('config', 'Permisos')" type="button" class="btn btn-secondary" @click="configModule(props)">
              <font-awesome-icon :icon="['fal', 'sliders-v']"/>
            </button>
          </span>
        </template>
      </vue-good-table>
    </div>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'

export default {
  mixins: [formatData],
  components: {
    VueGoodTable
  },
  data () {
    return {
      rows: [],
      isLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 10
      },
      columns: [
        {
          label: 'Id',
          field: 'admin_module_id',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Modulo',
          field: 'module_name',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Etiqueta',
          field: 'module_label',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Descripcion',
          field: 'module_description',
          filterOptions: {
            enabled: false
          }
        },
        {
          label: 'Acciones',
          field: 'actions',
          sortable: false
        }
      ]
    }
  },
  methods: {
    configModule (props) {
      this.$router.push({ name: 'modulesPermissionAdd', params: props })
    },
    updateParams (newProps) {
      this.serverParams = Object.assign({ page: 0 }, this.serverParams, newProps)
    },
    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange (params) {
      console.log(params)
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        }
      })
      this.loadItems()
    },
    onColumnFilter (params) {
      this.updateParams(params)
      this.loadItems()
    },
    async loadItems (first = false) {
      try {
        const items = {
          function: 'getModules',
          ...this.serverParams
        }
        const params = await this.toFormData(items)
        const response = await axiosAdelaService.post('/getModules', params)
        console.log(response)
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          this.rows = response.data.rows
        }
      } catch (error) {
        this.showError('No se pudieron obtener los usuarios intentalo mas tarde.')
      }
    }
  },
  async mounted () {
    this.loadItems(true)
  }
}
</script>

<style>

</style>
